import React, { useState } from 'react'
import { Button, Modal } from 'react-bootstrap'

import {
	TRevenueSpendByAccount, TRevenueSpendByAccountSpend
} from '../../types'
import { ToolPanel } from '../ui'
import { RevenueSpendByAccountSpendDetailsTable } from './RevenueSpendByAccountSpendDetailsTable'
import dt from 'dayjs'
import { useTranslation } from 'react-i18next'
import { ALL_LANG_KEY } from '../../types/lang'

type IRevenueSpendByAccountSpendDetailsModal = {
	revenueSpend: TRevenueSpendByAccount | TRevenueSpendByAccountSpend | null;
	show: boolean;
	take: number | 'all';
	onClose: () => void;
}

export const RevenueSpendByAccountSpendDetailsModal = (
	props: IRevenueSpendByAccountSpendDetailsModal
) => {
	const { revenueSpend, show, take = 10, onClose } = props
	const { t } = useTranslation()
	const [page, setPage] = useState<number>(0)
	const skip = (take === 'all') ? 0 : page > 0 ? page * take : 0

	const _getDateFormat = (at: Date) => {
		return dt.utc(at).isValid() ? dt.utc(at).format('L') : '-'
	}

	const isSingleView = !!(revenueSpend && ('registeredAt' in revenueSpend))
	const accountLabel = isSingleView && `'${revenueSpend?.auth?.login ?? ''}' [id: ${revenueSpend?.id ?? ''}]`
	const dayLabel = isSingleView && _getDateFormat(revenueSpend?.at)

	return <>
		<Modal show={show} onHide={onClose} size="xl" className={'modal-with-sticky scroll'}>
			<Modal.Header className={'modal-header--sticky'} closeButton>
				<Modal.Title>
					{
						isSingleView ?
							`${t(ALL_LANG_KEY.revenue_spend_crud_modal.title_by_account_spend, {
								account: accountLabel,
								date: dayLabel
							})}` :
							`${t(ALL_LANG_KEY.revenue_spend_crud_modal.title_by_account_spend_total)}`
					}
				</Modal.Title>
			</Modal.Header>

			<Modal.Body>
				<RevenueSpendByAccountSpendDetailsTable
					items={revenueSpend?.spend ?? []}
					skip={skip}
				/>
			</Modal.Body>

			<Modal.Footer className={'modal-footer--sticky'}>
				<ToolPanel flow="<-" width={'100%'}>
					<Button variant="secondary"
					        onClick={onClose}
					>
						{`${t(ALL_LANG_KEY.revenue_spend_crud_modal.btn_close)}`}
					</Button>
				</ToolPanel>

			</Modal.Footer>
		</Modal>
	</>
}
